export default {
  SHOP_NAME: 'Primum PURE. FRESH. SOFT.',
  ORG_NAME: 'Premium Pets Products GmbH',
  SEARCH_PAGE_TITLE: 'Primum - Suchergebnisse',
  PALI_PRODUCTS: [],
}
